import {Dimensions} from 'react-native';

const TABLE_CELL_HORIZONTAL_PADDING = 12;
export const TABLE_MIN_COLUMN_WIDTH = 104;
const TABLE_MAX_COLUMN_WIDTH = 240;
const TABLE_TEXT_WIDTH_MULTIPLIER = 8;
const APPROXIMATE_TABLE_AVAILABLE_WIDTH = Math.max(
  Dimensions.get('window').width - 112,
  TABLE_MIN_COLUMN_WIDTH,
);

const getApproximateTextWidth = (value: string): number =>
  value
    .split('\n')
    .reduce(
      (widestLine, line) =>
        Math.max(widestLine, line.trim().replace(/\s+/g, ' ').length),
      0,
    ) *
    TABLE_TEXT_WIDTH_MULTIPLIER +
  TABLE_CELL_HORIZONTAL_PADDING * 2;

export const getTableColumnWidths = (
  headers: string[],
  rows: string[][],
): number[] => {
  const measuredWidths = headers.map((header, columnIndex) => {
    const widestCellWidth = rows.reduce((widestWidth, row) => {
      return Math.max(
        widestWidth,
        getApproximateTextWidth(row[columnIndex] || ''),
      );
    }, 0);

    return Math.min(
      Math.max(
        TABLE_MIN_COLUMN_WIDTH,
        getApproximateTextWidth(header),
        widestCellWidth,
      ),
      TABLE_MAX_COLUMN_WIDTH,
    );
  });

  const measuredTotalWidth = measuredWidths.reduce(
    (totalWidth, width) => totalWidth + width,
    0,
  );

  if (measuredTotalWidth >= APPROXIMATE_TABLE_AVAILABLE_WIDTH) {
    return measuredWidths;
  }

  const extraWidthPerColumn =
    (APPROXIMATE_TABLE_AVAILABLE_WIDTH - measuredTotalWidth) /
    Math.max(measuredWidths.length, 1);

  return measuredWidths.map(width =>
    Math.min(width + extraWidthPerColumn, TABLE_MAX_COLUMN_WIDTH),
  );
};
